import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  const isLoading = ref(false)
  const isSidebarOpen = ref(false)
  const currentModal = ref(null)
  const notifications = ref([])
  const theme = ref(localStorage.getItem('theme') || 'light')
  
  const setLoading = (loading) => {
    isLoading.value = loading
  }
  
  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value
  }
  
  const openSidebar = () => {
    isSidebarOpen.value = true
  }
  
  const closeSidebar = () => {
    isSidebarOpen.value = false
  }
  
  const openModal = (modalName, data = null) => {
    currentModal.value = {
      name: modalName,
      data: data
    }
  }
  
  const closeModal = () => {
    currentModal.value = null
  }
  
  const addNotification = (notification) => {
    const id = Date.now() + Math.random()
    const newNotification = {
      id,
      type: 'info',
      title: '',
      message: '',
      duration: 5000,
      ...notification
    }
    
    notifications.value.push(newNotification)
    
    if (newNotification.duration > 0) {
      setTimeout(() => {
        removeNotification(id)
      }, newNotification.duration)
    }
    
    return id
  }
  
  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }
  
  const clearNotifications = () => {
    notifications.value = []
  }
  
  const setTheme = (newTheme) => {
    theme.value = newTheme
    localStorage.setItem('theme', newTheme)
    
    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }
  
  const toggleTheme = () => {
    setTheme(theme.value === 'light' ? 'dark' : 'light')
  }
  
  return {
    isLoading,
    isSidebarOpen,
    currentModal,
    notifications,
    theme,
    
    setLoading,
    toggleSidebar,
    openSidebar,
    closeSidebar,
    openModal,
    closeModal,
    addNotification,
    removeNotification,
    clearNotifications,
    setTheme,
    toggleTheme
  }
})